/* eslint-disable react/react-in-jsx-scope */
import React from 'react';
import PropTypes from 'prop-types';
export default function IconSearch({ className }){
  return(
    <svg className={className} fill="currentColor" height="18" viewBox="0 0 18 18" width="18" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.2935 14.4685L13.3729 11.5478C13.241 11.416 13.0623 11.3428 12.8749 11.3428H12.3974C13.2059 10.3087 13.6863 9.00806 13.6863 7.59316C13.6863 4.22727 10.959 1.5 7.59316 1.5C4.22727 1.5 1.5 4.22727 1.5 7.59316C1.5 10.959 4.22727 13.6863 7.59316 13.6863C9.00806 13.6863 10.3087 13.2059 11.3428 12.3974V12.8749C11.3428 13.0623 11.416 13.241 11.5478 13.3729L14.4685 16.2935C14.7438 16.5688 15.1891 16.5688 15.4615 16.2935L16.2905 15.4645C16.5659 15.1891 16.5659 14.7438 16.2935 14.4685ZM7.59316 11.3428C5.52207 11.3428 3.84352 9.66717 3.84352 7.59316C3.84352 5.52207 5.51914 3.84352 7.59316 3.84352C9.66424 3.84352 11.3428 5.51914 11.3428 7.59316C11.3428 9.66424 9.66717 11.3428 7.59316 11.3428Z" fill="currentColor"/>
    </svg>
  );
}
IconSearch.propTypes = {
  className: PropTypes.string
};
